<template>
    <div class="custom-checkbox-wrapper">
    	<div :class="['custom-checkbox', { checked: localValue }, { disabled: disabled }]" @click="doToggle()" tabindex="0"><i v-if="localValue" class="fa fa-check" /></div><label class="inline">{{ label }}</label>
    </div>
</template>
<script>
export default {
	name: 'binary-toggle',
	props: {
		value: {
			type: [Number, String, Boolean],
			required: false
		},
		label: {
			type: [String],
			required: false,
		},
		default: {
			type: [Boolean, String],
			required: false,
		},
		disabled: {
			type: [Boolean, String, Number],
			required: false,
			default: false
		}
	},
	data() {
		return {
			localValue: ''
		}
	},
	computed: {
		isDisabled() {
			return this.disabled != 0 && this.disabled != ''
		}
	},
	created() {
		if (this.default && !this.value) {
			this.localValue = this.default
		} else {
			this.localValue = this.value
		}
	},
	watch: {
		value(newVal) {
			this.localValue = newVal
		}
	},
	methods: {
		doToggle() {
			if (this.disabled) { return }
            this.localValue = !this.localValue
			this.$emit('input', this.localValue)
		}
	}
}
</script>

<style lang="scss" scoped>
.custom-checkbox-wrapper {
    display: grid;
    grid-template-columns: 2em 1fr;
    align-items: center;
    .custom-checkbox {
        display: inline-block;
        width: 1.5em; height: 1.5em !important;
        padding: 0.15em 0 0 0;
        text-align: center;
        border-radius: 4px;
        border: 2px solid #4a4a4a;
        cursor: pointer;
        &.checked {
            color: #ffffff;
      		background: #4a4a4a;
        }
    }
}
</style>
